/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cross': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M46.038 1.962a3.286 3.286 0 0 1 0 4.647L6.609 46.038a3.286 3.286 0 1 1-4.647-4.647L41.391 1.962a3.286 3.286 0 0 1 4.647 0z" _fill="#000"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M1.962 1.962a3.286 3.286 0 0 1 4.647 0l39.429 39.429a3.286 3.286 0 1 1-4.647 4.647L1.962 6.609a3.286 3.286 0 0 1 0-4.647z" _fill="#000"/>'
  }
})
